export const SUBSCRIPTION_CREATOR_TRIAL = 0;
export const SUBSCRIPTION_CREATOR = 1;
export const SUBSCRIPTION_BUISNESS_BASIC_TRIAL = 2;
export const SUBSCRIPTION_BUISNESS_BASIC = 3;
export const SUBSCRIPTION_BUISNESS_PRO = 4;
export const SUBSCRIPTION_ENTERPRISE = 5;
